export default "__VITE_ASSET__DxzatOo8__"